import axios from "axios";
import qs from "qs";

export const qwCinemas = axios.create({
  baseURL: process.env.QW_CINEMAS_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "comma" }),
});

qwCinemas.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && process.env.HOME_PAGE_URL) {
      window.location.href = process.env.HOME_PAGE_URL;
    }
    return Promise.reject(error);
  },
);
